import Title from './Title'
import classNames from 'classnames'
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react'
import { Autoplay, Pagination } from 'swiper'
import { useEffect, useMemo, useState } from 'react'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'
import { CDNImage } from '~/components/business/CDNImage'
import { MyContainer } from '~/components/ui/MyContainer'
import TabPagination from './TabPagination'

const cases = [
  {
    id: '1',
    title: '武林夜市摆摊',
    desc: '只需一部安卓设备和一台打印机，就能轻松出摊，低成本打造高收益副业模式，4小时轻松赚1000+。',
    img: 'https://cdn.wujiebantu.com/upload/50B09C17B7AE9774ACBD82A331E58C4F/1725242616169/FlXWI-jnsaBcriKmb6lv3XmUt7o8.jpg',
    items: [
      { value: 120, label: '日成单', trendType: 'up' },
      { value: 80, label: '日营收', trendType: 'up' },
      { value: 55, label: '日成本', trendType: 'down' },
      { value: 300, label: '社媒转化', trendType: 'up' },
    ],
  },
  {
    id: '2',
    title: '新型照相馆（杭州某新锐照相馆 ）',
    desc: '为照相馆定制AIGC升级体系，把常规照相馆行业的店面面积从55平米缩减到25平米，雇佣人员从3-6人减少为1-2人，到从而为客户提供更优惠、更便捷、更多个性化的服务。',
    img: 'https://cdn.wujiebantu.com/upload/50B09C17B7AE9774ACBD82A331E58C4F/1725242713395/FkRKsZbuIOzsfkJNAhPHcHpZsvAg.jpg',
    items: [
      { value: 187, label: '月成单', trendType: 'up' },
      { value: 95, label: '月营收', trendType: 'up' },
      { value: 68, label: '月成本', trendType: 'down' },
      { value: 177, label: '二次增购率', trendType: 'up' },
    ],
  },
  {
    id: '3',
    title: '游乐场、商超、景区打卡项目',
    desc: '针对全年龄层定制多款模型，增加消费者场景互动体验感。',
    img: 'https://cdn.wujiebantu.com/upload/50B09C17B7AE9774ACBD82A331E58C4F/1725242808900/FpcY-N_LATheqWzNWthJ6L3RI-xh.jpg',
    items: [
      { value: 86, label: '月成单', trendType: 'up' },
      { value: 158, label: '月营收', trendType: 'up' },
      { value: 35, label: '月成本', trendType: 'down' },
      { value: 383, label: '社媒转化', trendType: 'up' },
    ],
  },
  {
    id: '4',
    title: '营销引流项目( 某化妆品厂牌线下仿妆活动 ）',
    desc: '厂牌新品发布会的现场，定制“四大美人仿妆”自拍机，为试装后的客人提供古风自拍服务，活动现场人流涌动，是一场特别成功的品牌营销活动。',
    img: 'https://cdn.wujiebantu.com/upload/50B09C17B7AE9774ACBD82A331E58C4F/1725242901885/FqgBoGhg1rMerwzRFZbG_NkBE8f2.jpg',
    items: [
      { value: 35, label: '网店新用户', trendType: 'up' },
      { value: 28, label: '新品销售', trendType: 'up' },
      { value: 56, label: '品牌关注度', trendType: 'up' },
      { value: 85, label: '社媒转化', trendType: 'up' },
    ],
  },
  {
    id: '5',
    title: '海外市场',
    desc: '根据不同国家的风俗人情，我们量身定制专属景区和博物馆等场景的拍照模板。结合最先进的AI拍照技术，为用户提供无与伦比的拍摄体验。',
    img: 'https://cdn.wujiebantu.com/upload/B75546EEE5A433E197ABE572FA2D37AA/ai_init_image/1756977076092/FgTAUSu1pP0hcLexqSnryzXbCWOK.png',
    items: [
      { value: 200, label: '月成单', trendType: 'up' },
      { value: 160, label: '月营收', trendType: 'up' },
      { value: 40, label: '月成本', trendType: 'down' },
      { value: 350, label: '社媒转化', trendType: 'up' },
    ],
  },
]

function Partnerships() {
  const [activeKey, setActiveKey] = useState<string>('1')
  const syncSliderTypeToTab = (idx: number) => {
    setActiveKey(cases[idx].id)
  }
  return (
    <section className="w-full mt-[64px] pb-[64px]">
      <MyContainer className="!w-[1424px] !p-0">
        <Title text="合作案例" desc="Partnerships" />
        <div className="mt-6">
          <Swiper
            effect={'coverflow'}
            modules={[Pagination, Autoplay]}
            // hack: 不能为1，为1，loop的时候swiper某些情况下，不会生成下一个slider的预览
            slidesPerView={1.001}
            width={1424}
            spaceBetween={24}
            centeredSlides={true}
            loop={true}
            coverflowEffect={{
              rotate: 0,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: false,
            }}
            navigation={{
              enabled: true,
            }}
            onActiveIndexChange={(swiper: any) => {
              syncSliderTypeToTab(swiper.realIndex)
            }}
            autoplay={{
              delay: 3000,
              pauseOnMouseEnter: true,
              disableOnInteraction: false,
              waitForTransition: true,
            }}
            speed={1500}
            allowTouchMove
          >
            {cases.map(it => {
              return (
                <SwiperSlide key={it.id}>
                  <div className="w-full h-full flex items-center justify-between pt-6 px-[88px] select-none">
                    <div className="flex-1 mr-[48px]">
                      <div className="text-[24px] font-semibold text-[#101828]">
                        {it.title}
                      </div>
                      <div className="text-sm font-semibold text-neutral-400 mt-4 mb-8">
                        {it.desc}
                      </div>
                      <div className="flex flex-wrap">
                        {it.items.map(subIt => (
                          <div
                            key={subIt.label}
                            className="rounded-[16px] bg-neutral-700 p-4 mr-5 mb-5 even:mr-0 flex flex-col items-center"
                            style={{ width: 'calc(50% - 10px)' }}
                          >
                            <div className="flex flex-col items-center">
                              <div className="flex items-center">
                                <div className="text-[24px] font-semibold text-neutral-200 mr-1">
                                  {subIt.value}%
                                </div>
                                <CDNImage
                                  src={`/images/mirror/${subIt.trendType}-icon.svg`}
                                />
                              </div>
                              <div className="text-sm text-neutral-400 mt-1 leading-none">
                                {subIt.label}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="h-full relative pb-[64px]">
                      <img
                        style={{
                          boxShadow: '0px 20px 30px 0px rgba(0, 0, 0, 0.16)',
                        }}
                        src={it.img}
                        alt=""
                        className="w-full h-[410px] object-contain rounded-[14px]"
                      />
                    </div>
                  </div>
                </SwiperSlide>
              )
            })}

            <TabPagination cases={cases} />
          </Swiper>
        </div>
      </MyContainer>
    </section>
  )
}

export default Partnerships
